import React, { useState } from 'react';
import { DownloadIcon } from '@chakra-ui/icons';
import { Button } from '@chakra-ui/react';
import { PwaInstallModal } from './PwaInstallModal';

export const PwaInstall = () => {

    const [openModal, setOpenModal] = useState(false);

    return (
        <>
            <Button
                rightIcon={<DownloadIcon color='gray.600' boxSize={4} />}
                w='100%'
                onClick={() => setOpenModal(true)}
                fontWeight={400}
                size="lg"
                variant="tertiary"
                color='black'
                _hover={{ backgroundColor: 'white', textColor: 'black' }}
                display='flex'
                justifyContent='space-between'
                height="auto"
                p={{
                    base: 4,
                    md: 3,
                }}
                lineHeight={1}
            >
                Install App
            </Button>

            {openModal &&
                <PwaInstallModal openModal={openModal} />
            }
        </>
    )
}